import React from 'react';
import PhoneInput, {PhoneInputProps} from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
/**
 * Interfaces for Phone Input
 */
export interface PhoneInputFieldProps extends PhoneInputProps {
  handleOnChange?(value: string): void;
  error?: boolean;
}

const PhoneInputField = (props: PhoneInputFieldProps): React.ReactElement => {
  return (
    <PhoneInput
      containerClass="phone-wrapper-container"
      inputClass={`phone-input-container ${
        props.error ? 'phone-error' : props.disabled ? 'phone-text' : ''
      }`}
      dropdownClass="phone-drop-down-container"
      country={'us'}
      value={''}
      data-test-id="pcl-payments-phoneInput"
      disableCountryCode={true}
      disableCountryGuess={true}
      countryCodeEditable={true}
      onlyCountries={['us']}
      disableDropdown={true}
      {...props}
    />
  );
};

export default PhoneInputField;
